import { render } from "./WarehouseRequisitions.vue?vue&type=template&id=d21bb3ae&scoped=true"
import script from "./WarehouseRequisitions.vue?vue&type=script&lang=js"
export * from "./WarehouseRequisitions.vue?vue&type=script&lang=js"

import "@/styles/warehouse.css?vue&type=style&index=0&id=d21bb3ae&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d21bb3ae"]])

export default __exports__